import React from 'react';
import styled from 'styled-components';

import { colors } from '../config';

const LogoSVG = styled.svg`
  &,
  use {
    transition: all ease-in-out 0.2s;
    transition-property: fill, opacity;
  }
`;

const LogoSymbol = ({ isDark = false }) => (
  <LogoSVG viewBox="0 0 434 282.1">
    <defs>
      <linearGradient
        id="logo-gradient"
        x1="37.97"
        y1="320.07"
        x2="396.02"
        y2="-37.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor={colors.secondary} />
        <stop offset="1" stopColor={colors.primary} />
      </linearGradient>

      <path
        id="logo-symbol"
        d="M434,0V282.1H402V264.51a82.56,82.56,0,0,1-51,17.59h0a82.78,82.78,0,0,1-60.82-26.62l14.3-35.56a51,51,0,1,0,27.37-68.06l14.31-35.6c1.61-.09,3.23-.15,4.86-.15a82.56,82.56,0,0,1,51,17.59V0ZM134,148.1a34,34,0,0,0-34,34v100h68v-100A34,34,0,0,0,134,148.1ZM360.88,0H0V282.1H68v-166h32v9.45a65.86,65.86,0,0,1,84,13.54A65.93,65.93,0,0,1,296.35,160.5ZM234,148.1a34,34,0,0,0-34,34v100h47.46L268,231V182.1A34,34,0,0,0,234,148.1Z"
      />
    </defs>

    <use href="#logo-symbol" fill="#fff" opacity={isDark ? 1 : 0} />
    <use
      href="#logo-symbol"
      fill="url(#logo-gradient)"
      opacity={isDark ? 0 : 1}
    />
  </LogoSVG>
);

const LogoTextSVG = styled(LogoSVG)`
  margin-left: 10px;
`;

const LogoText = ({ isDark = false }) => (
  <LogoTextSVG viewBox="0 0 646.523 282.1" fill={isDark ? '#fff' : ''}>
    <path d="M0,163.866H36.683q26.617,0,39.156,14.928t12.539,44.274a104.335,104.335,0,0,1-2.559,23.97,49.807,49.807,0,0,1-8.445,18.683,38.268,38.268,0,0,1-15.611,12.114Q52.038,282.1,37.706,282.1H0Zm23.885,22.692v72.849h13.82q7.845,0,12.967-2.474a19.753,19.753,0,0,0,8.189-7.251,31,31,0,0,0,4.265-11.428,86.674,86.674,0,0,0,1.2-15.186q0-18.595-6.569-27.555t-21.072-8.955Zm159.436.163H131.793v24.91h48.46v22.524h-48.46v25.08h52.895V282.1H107.906V163.858h75.416Zm84.616,95.37L239.1,236.88H227.16v45.212H203.275V163.858h39.071a66.065,66.065,0,0,1,17.487,2.219,40.909,40.909,0,0,1,13.99,6.654,30.425,30.425,0,0,1,9.215,11.431,37.794,37.794,0,0,1,3.327,16.379q0,12.284-5.461,20.474a30.2,30.2,0,0,1-15.7,11.771l30.882,49.307ZM227.16,186.55v27.807h18.768q8.191,0,12.2-3.242t4.01-10.576q0-7.166-4.608-10.578a18.968,18.968,0,0,0-11.6-3.412Zm122.329,62.1,27.3-84.794h25.081L360.92,282.092H337.545L296.428,163.858h25.764Zm86.669-84.794V282.092H412.273V163.858Zm41.713,82.371a17.238,17.238,0,0,0,7.721,10.3,24.567,24.567,0,0,0,13.038,3.487,28.738,28.738,0,0,0,6.311-.747,21.158,21.158,0,0,0,6.143-2.408,16.344,16.344,0,0,0,4.65-3.986,8.855,8.855,0,0,0,1.826-5.646,10.092,10.092,0,0,0-1.909-6.311,14.962,14.962,0,0,0-5.147-4.151,39.1,39.1,0,0,0-7.475-2.822q-4.233-1.161-8.884-2.16-6.643-1.494-13.284-3.489a42.333,42.333,0,0,1-12.043-5.729,28.919,28.919,0,0,1-8.8-9.8q-3.4-6.059-3.4-15.86a31.532,31.532,0,0,1,3.073-14.282,29.074,29.074,0,0,1,8.553-10.3,39.416,39.416,0,0,1,12.87-6.311,56.425,56.425,0,0,1,15.86-2.157,58.635,58.635,0,0,1,17.6,2.408,35.416,35.416,0,0,1,12.787,6.89,31.335,31.335,0,0,1,7.971,10.63,38.57,38.57,0,0,1,3.321,13.618H515.569a12.9,12.9,0,0,0-6.311-8.884,21.947,21.947,0,0,0-11.458-3.073q-8.309,0-13.287,3.073t-4.982,7.889a6.752,6.752,0,0,0,1.743,4.731,15.1,15.1,0,0,0,4.65,3.324,40,40,0,0,0,6.808,2.491q3.9,1.081,8.222,2.074,6.808,1.662,13.949,3.9a45.722,45.722,0,0,1,12.953,6.394,33.308,33.308,0,0,1,9.549,10.63q3.736,6.475,3.737,16.605a34.737,34.737,0,0,1-3.4,15.86,30.95,30.95,0,0,1-9.218,11.044,40.832,40.832,0,0,1-13.535,6.476,60.5,60.5,0,0,1-16.357,2.16,72.053,72.053,0,0,1-17.355-1.994,40.083,40.083,0,0,1-14.117-6.394,33.587,33.587,0,0,1-9.8-11.21,37.537,37.537,0,0,1-4.234-16.274Zm144.936-82.371h23.715V282.092H622.807V232.615H582.03v49.477H558.145V163.858H582.03v46.235h40.777ZM64.729,90.812,100.521,0h29.128V131.934H103.185V55.21L73.867,131.934H55.4L26.272,55.21v76.724H0V0H29.128Zm175.337-65.3h-57.5v27.8h54.068v25.13H182.571v27.986H241.59v25.511H155.919V0h84.147Zm94.428,106.423-32.175-50.45H288.992v50.45H262.34V0h43.6a73.8,73.8,0,0,1,19.515,2.475A45.742,45.742,0,0,1,341.062,9.9a33.941,33.941,0,0,1,10.28,12.756,42.145,42.145,0,0,1,3.712,18.277q0,13.707-6.092,22.845a33.685,33.685,0,0,1-17.516,13.137l34.46,55.02ZM288.992,25.32V56.352h20.943q9.138,0,13.611-3.616t4.475-11.8q0-8-5.141-11.8T309.935,25.32ZM474.23,0V25.32H435.582V131.934H409.12V25.32H370.662V0Zm42.643,0V131.934H490.221V0Zm129.65,131.934h-27.8l-49.117-85.1v85.1H543.147V0h27.795l48.928,84.529V0h26.653Z" />
  </LogoTextSVG>
);

const Logo = ({ isDark = false }) => (
  <>
    <LogoSymbol isDark={isDark} />
    <LogoText isDark={isDark} />
  </>
);

export default Logo;
